export enum UploadIdOcrStatesEnumeration {
  ACCEPTED = 'ACCEPTED', // Verify data
  NEEDS_CUSTOMER_CONFIRM = 'NEEDS_CUSTOMER_CONFIRM', // Iframe
  REJECTED = 'REJECTED', // Take a photo
}
